import { Check, Copy } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { Button } from '../../Shared/UI/Button';
import { Card } from '../../Shared/UI/Card';
import { FadeIn } from '../../Shared/UI/FadeIn';
import { Icon } from '../../Shared/UI/Icon';
import { useCopy } from '../../Shared/useCopy';

interface EmbedScriptsCardProps {
  elementSnippet: string;
}

export default function EmbedScriptsCard({ elementSnippet }: EmbedScriptsCardProps) {
  const { t } = useTranslation();

  const globalSnippet = '<script type="text/javascript" src="https://cdn.supporta.com/embed.js" async></script>';

  const [copyElement, copiedElement] = useCopy(elementSnippet);
  const [copyGlobal, copiedGlobal] = useCopy(globalSnippet);

  return (
    <Card panels header>
      <div>
        <div className="flex items-center space-x-4 leading-tight">
          <span className="flex items-center justify-center w-10 h-10 font-medium text-blue-700 bg-blue-200 rounded-full">
            2
          </span>
          <div>
            <h3 className="flex items-center">
              {t('backend:embed')}
            </h3>
            <p className="text-slate-500">
              {t('backend:embed_scripts_description')}
            </p>
          </div>
        </div>
      </div>
      <div>
        <h3>
          {t('backend:embed_global_script_title')}
        </h3>
        <p className="mb-2">
          {t('backend:embed_global_script_description')}
        </p>
        <code className="block p-4 overflow-x-auto text-xs border-solid text-slate-500 bg-slate-100 border-slate-300 border-y-1 border-x-1 whitespace-nowrap">
          {globalSnippet}
        </code>

        <Button onClick={copyGlobal} className="mt-2" variant="secondary">
          <Icon className="mr-1">
            {copiedGlobal ? <Check /> : <Copy />}
          </Icon>
          {t('backend:copy')}
        </Button>
      </div>
      <div>
        <h3>
          {t('backend:embed_element_title')}
        </h3>
        <p className="mb-2">
          {t('backend:embed_element_description')}
        </p>
        <FadeIn key={elementSnippet}>
          <code
            aria-label={t('backend:embed_element_label')}
            className="block p-4 overflow-x-auto text-xs border-solid text-slate-500 bg-slate-100 border-slate-300 border-y-1 border-x-1 whitespace-nowrap">
            {elementSnippet}
          </code>
        </FadeIn>
        <Button onClick={copyElement} className="mt-2" variant="secondary">
          <Icon className="mr-1">
            {copiedElement ? <Check /> : <Copy />}
          </Icon>
          {t('backend:copy')}
        </Button>
      </div>
    </Card>
  );
}
